import requestAPI from './requestAPI';
import addPropsToDirsAndFiles from './addPropsToDirsAndFiles';

const setDataInFileBrowser = (params, sites, setData, siteId) => {
  requestAPI(params)
  .then((response) => {
    const siteName = sites[sites.findIndex((el) => el.title === siteId)].value;
    addPropsToDirsAndFiles(response, siteName, setData, siteId)
  });
};

export default setDataInFileBrowser;
